export default function PostEditScreen() {
  return null;
}
